import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  root: {
    height: theme.sidePanel.brandingHeight + 'rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid ' + theme.palette.hr.main,
    '& > img': {
      height: '70%',
    },
    [theme.breakpoints.downWithLandscape('mobile')]: {
      position: 'absolute',
      top: '0.15rem',
      left: 0,
      height: '3rem',
      borderBottomWidth: 0,
    },
  },
});

const SidePanelBranding = ({ classes }) => (
  <div className={classes.root}>
    <img src="/mac-summit-logo.svg" alt="MAC Summit logo" />
  </div>
);

export default withStyles(styles)(SidePanelBranding);

SidePanelBranding.propTypes = {
  classes: PropTypes.object,
};
